import errors from "../errors";
import validate from "../validate";
const { SystemError, MatchError } = errors;
type ErrorKeys = keyof typeof errors;

interface ItemInput {
    id: string;
    description: string;
    quantity: number;
    name?: string;
}

async function createOrder(
    userId: string,
    items: ItemInput[],
    shippingAddress: string,
    phoneNumber: number,
    totalAmount: number
): Promise<void> {
    validate.id(userId, 'userId');
    items.forEach(item => {
        validate.id(item.id, 'itemId');
        validate.number(item.quantity, 'quantity');

        if (item.name && item.name.toLowerCase() === "camiseta") {
            validate.text(item.description, 'description');
        } else {
            item.description = item.description || "";
        }
    });
    validate.text(shippingAddress, 'shippingAddress');
    validate.number(phoneNumber, 'phoneNumber');
    validate.number(totalAmount, 'totalAmount');

    const payload = {
        userId,
        items: items.map(item => ({
            id: item.id,
            description: item.description,
            quantity: item.quantity
        })),
        shippingAddress,
        phoneNumber,
        totalAmount
    };

    return fetch(`${process.env.NEXT_PUBLIC_API_URL}/orders`, {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${sessionStorage.token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    })
        .catch(error => { throw new SystemError(error.message) })
        .then(res => {
            if (res.status === 201) return;

            return res.json()
                .catch(error => { throw new SystemError(error.message) })
                .then(body => {
                    const { error, message } = body;
                    const constructor = errors[error as ErrorKeys];
                    if (constructor) {
                        throw new constructor(message);
                    } else {
                        throw new SystemError(message);
                    }
                });
        });
}

export default createOrder;
